import { useState } from "react";

export const useMyDataRequest = () => {
  // Select 상태 관리
  const [periodicTransfer, setPeriodicTransfer] = useState("ONCE_A_WEEK");
  const [endDate, setEndDate] = useState<"ONE_YEAR" | "SIX_MONTH">("ONE_YEAR");

  return {
    periodicTransfer,
    setPeriodicTransfer,
    endDate,
    setEndDate,
  };
};
